import { render, staticRenderFns } from "./gamescores.vue?vue&type=template&id=f3cfc4a4&scoped=true"
import script from "./gamescores.vue?vue&type=script&lang=js"
export * from "./gamescores.vue?vue&type=script&lang=js"
import style0 from "./gamescores.vue?vue&type=style&index=0&id=f3cfc4a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cfc4a4",
  null
  
)

export default component.exports